import apiClient from '../axios.js'

/**
 * 客戶選購模組管理 API
 */
export const clientOptionalModuleService = {
    /**
     * 獲取客戶選購模組列表
     * @param {string} clientId - 客戶 ID
     * @param {boolean} includeInactive - 是否包含已停用的模組
     * @returns {Promise<Object>} 選購模組列表
     */
    getClientOptionalModules: async (clientId, includeInactive = false) => {
        const response = await apiClient.get(`/system/clients/${clientId}/optional-modules`, {
            params: { includeInactive }
        })
        return response
    },

    /**
     * 添加選購模組
     * @param {string} clientId - 客戶 ID
     * @param {Object} moduleData - 模組資料
     * @param {string} moduleData.moduleId - 模組 ID
     * @param {number} moduleData.monthlyPrice - 月費（可選，未提供則使用模組預設價格）
     * @param {string} moduleData.billingCycle - 計費週期（可選，預設 monthly）
     * @param {string} moduleData.startDate - 開始日期（可選，預設今天）
     * @param {string} moduleData.endDate - 結束日期（可選）
     * @param {string} moduleData.notes - 備註（可選）
     * @returns {Promise<Object>} 添加結果
     */
    addOptionalModule: async (clientId, moduleData) => {
        const response = await apiClient.post(`/system/clients/${clientId}/optional-modules`, moduleData)
        return response
    },

    /**
     * 移除選購模組
     * @param {string} clientId - 客戶 ID
     * @param {string} moduleId - 模組 ID
     * @returns {Promise<Object>} 移除結果
     */
    removeOptionalModule: async (clientId, moduleId) => {
        const response = await apiClient.delete(`/system/clients/${clientId}/optional-modules/${moduleId}`)
        return response
    },

    /**
     * 獲取可選購的模組列表
     * @param {string} clientId - 客戶 ID
     * @returns {Promise<Object>} 可選購的模組列表
     */
    getAvailableOptionalModules: async (clientId) => {
        const response = await apiClient.get(`/system/clients/${clientId}/optional-modules/available`)
        return response
    },

    /**
     * 取消選購模組（設置結束日期為下次收費日期之前）
     * @param {string} clientId - 客戶 ID
     * @param {string} moduleId - 模組 ID
     * @returns {Promise<Object>} 取消結果
     */
    cancelOptionalModule: async (clientId, moduleId) => {
        const response = await apiClient.post(`/system/clients/${clientId}/optional-modules/${moduleId}/cancel`)
        return response
    },

    /**
     * 更新 ChatDesk 加購座席數
     * @param {string} clientId - 客戶 ID
     * @param {string} moduleId - 模組 ID
     * @param {number} extraSeats - 加購座席數（不含內含 3 席）
     * @param {Object} [options]
     * @param {boolean} [options.recordPayment] - 加席時是否同時記錄人工收款
     * @param {string} [options.paymentDate] - 收款日期 YYYY-MM-DD
     * @param {string} [options.notes] - 備註
     * @returns {Promise<Object>} 更新結果
     */
    updateChatDeskSeats: async (clientId, moduleId, extraSeats, options = {}) => {
        const body = { extraSeats }
        if (options.recordPayment) {
            body.recordPayment = true
            if (options.paymentDate) body.paymentDate = options.paymentDate
            if (options.notes) body.notes = options.notes
        }
        const response = await apiClient.patch(
            `/system/clients/${clientId}/optional-modules/${moduleId}/seats`,
            body
        )
        return response
    },
}
